module.exports = __webpack_public_path__ + "static/media/view room.380fb736.svg";